/// <reference types="moment" />

/**
* Web Service handler to retrieve and represent available appointment time blocks
*
* @class PossibleTimeBlocksWS
*/
function PossibleTimeBlocksWS(viewModel) {
  var self = this;

  AbstractWS.apply(self, arguments);

  self.method = ko.observable('POST');
  self.name = 'PossibleTimeBlocksWS';
  self.end = ko.observable(null);
  self.start = ko.observable(null);
  self.lastStart = ko.observable(new moment());
  self.direction = 0;

  self.blocks = ko.observableArray([]);
  self.daysFromFirst = ko.observable(0);
  self.firstDate = ko.observable(null);
  self.loadedOnce = ko.observable(false);
  self.loading = ko.observable(false);
  self.locale = ko.observable('en_US');
  self.maxDays = ko.observable(1);
  self.noResults = ko.observable(false);
  self.partySize = ko.observable(null);
  self.queueId = ko.observable(null);
  self.remote = ko.observable(false);
  self.resourceId = ko.observable(null);
  self.transactionTypeIds = ko.observable(null);

  self.appointmentDate = ko.observable('TODAY!');

	/**
	* API Endpoint
	*
	* @method serviceURL
	* @return {String}
	*/
  self.serviceURL = ko.computed(function () {
    return '/qless/api/v1/appointment/queue/' + self.queueId() + '/possibleBlocks';
  });


	/**
	* Creates a parameter object to send along with the API request
	*
	* @method generateParams
	* @return {Object}
	*/
  self.generateParams = function () {
    var dEnd = new moment(qcal.currentWeek().days[6].date),
      obj = {
        // end: dEnd.toISOString(),
        //locale: self.locale() || self.VM.browserLocale,
        maxDays: 7,
        partySize: null,
        remote: false,
        start: self.getFirstStartDate(),
        timeZone: self.timeZone(),
        transactionTypeIds: self.transactionTypeIds(),
        wssid: qcal.wssid()
      };

    if (self.resourceId() != null) {
      obj.resourceId = self.resourceId();
    }

    dEnd.add(1, 'days');

    return obj;
  };


	/**
	* Returns the start date for the parameters. If Today is after the first day of
	* the week, return that day instead
	*
	* @method getFirstStartDate
	* @return {String}
	*/
  self.getFirstStartDate = function () {
    // Get the first day of the week and a new moment representing today
    /** @type {moment.Moment} */
    var startOfWeek = qcal.currentWeek().days[0].date;

    /** @type {moment.Moment} */
    var now = new moment();

    var startOfToday = now.clone();

    var tz = self.parent.timeZoneControl.selectedTZ();
    if (tz) {
      startOfWeek.tz(tz.olson[0]);
      now.tz(tz.olson[0]);
      startOfToday.tz(tz.olson[0]);
    }

    // Make sure today is set to 12 midnight
    startOfToday.startOf("day")

    // If the first day of the week is not today, return today as the start
    return (startOfWeek.isBefore(startOfToday)) ? now.toISOString(true) : startOfWeek.toISOString(true);
  };


	/**
	* Requests data from the API service
	*
	* @method doRequest
	* @return none
	*/
  self.doRequest = function () {
    if (self.queueId() != null && self.transactionTypeIds() != null) {
      qcal.setStatusMessage('Requesting possible time blocks');
      self.noResults(false);

      self.params = self.generateParams();

      AbstractWS.prototype.doRequest.apply(self, arguments);
    }
  };


	/**
	* Returns the shortest duration in minutes of returned possible
	* time blocks. This allows the interface to scale if the duration
	* in minutes is less than 30 minutes.
	*
	* @method minDuration
	* @return {Number}
	*/
  self.minDuration = ko.computed(function () {
    var i = 0,			// Standard increment
      iReturn = 0,	// return value
      oBlock = null;	// Temporary instance of a TimeBlockModel

    self.blocks().forEach(function (block) {
      // Only consider blocks that have their units in minutes
      if (block.durationUnits == 'minutes' || block.durationUnits == 'min') {
        iReturn = Math.max(iReturn, block.durationValue);
      }
    });

    if (iReturn == 0) {
      iReturn = 30;
    }

    self.blocks().forEach(function (block, idx) {
      if (idx != 0) {
        // If the index is greater that one (so we have something to compare it against)
        // get the min of the existing iReturn and the start time of the current block minus the
        // start time of the previous block, expressed in minutes (not milliseconds)
        iReturn = Math.min(iReturn, ((block.getDate().valueOf() - self.blocks()[idx - 1].getDate().valueOf()) / (1000 * 60)));
      }
    });

    return iReturn;
  });


	/**
	* Converts XML data returned from the API into a collection of TimeBlockModels
	*
	* @method processData
	* @param {XMLDocument} data
	* @return none
	*/
  self.processData = function (data) {
    // console.log(data);
    var aTemp = [],
      blocks,
      dt = null,
      s = null,
      timeBlock = null,
      timeBlocksArr = [];

    qcal.setStatusMessage('Possible time blocks received', 1000);

    self.blocks.removeAll();

    blocks = $(data).find('timeBlock').toArray();

    if (blocks.length > 0) {

      // Load the created TimeBlockModels to a temporary array
      blocks.forEach(function (block) {
        aTemp.push(new TimeBlockModel(block));
      });

      // Load the temporary array into the observable array
      // This prevents successive firing of any methods or observables
      // that are bound to this collection.
      self.blocks(aTemp);

      self.blocks.notifySubscribers();

      setTimeout(qcal.updateHourIndicator, 200);

    }
    else {
      self.noResults(true);
    }

    AbstractWS.prototype.processData.apply(self, arguments);
  };



	/**
	* This method returns the possibleTimeBlocks to it's default state
	*
	* @method reset
	* @return {Array} array of time blocks
	*/
  self.reset = function () {
    self.blocks.removeAll();
    self.noResults(false);
    self.transactionTypeIds = ko.observable(null);

    return self;
  };



	/**
	* This method returns the TimeBlockModels for a specified date
	*
	* @method timeBlocksByDate
	* @param {Moment} mDate
	* @return {Array}
	*/
  self.timeBlocksByDate = function (mDate) {
    return self.blocks().reduce(function (arr, block, idx) {
      var m = block.getDate();
      var oPrevTBM = null;

      var isSameDay = moment(m.format("YYYY-MM-DD"))
        .isSame(mDate.format("YYYY-MM-DD"), 'day')

      // WARNING:
      // Create two new moments from the date strings only and compare.
      // Comparing two *existing Moment objects* doesn't always work.
      //
      // The documentation <https://momentjs.com/docs/#/query/is-same/> warns that isSame
      // has undefined behaviour and numerous people
      // have had issues: https://github.com/moment/moment/issues?q=is%3Aissue+isSame

      if (isSameDay) {
        // Overlapping blocks are only possible when there is
        // at least one other TimeBlockModel in the return array
        if (arr.length > 0) {
          // Examine the end time of the previous TimeBlockModel
          // If it occurs after this TimeBlockModel starts, then
          // both it and this are overlapping
          oPrevTBM = self.blocks()[idx - 1];

          if (oPrevTBM.end().valueOf() > m.valueOf()) {
            block.isOverlap = true;
            oPrevTBM.isOverlap = true;
          }
        }

        arr.push(block);
      }

      return arr;
    }, []);
  };



	/**
	* This method returns the TimeBlockModels for a specified date, grouped by start time
	*
	* @method timeBlocksGroupedByDate
	* @param {Moment} mDate
	* @return {Array}
	*/
  self.timeBlocksGroupedByDate = function (mDate) {
    var block = null;
    var blocks = self.timeBlocksByDate(mDate);
    var blockLen = blocks.length;
    var group = null;
    var groups = [];
    var i = 0;
    var j = 0;

    if (blockLen === 0) {
      return [];
    }

    for (i = 0; i < blockLen; i++) {
      block = blocks[i];
      bFoundHome = false;

      if (block.isOverlap === true) {

        for (j = 0; j < groups.length; j++) {
          group = groups[j];

          if (group[group.length - 1].end().valueOf() <= block.getDate().valueOf()) {
            bFoundHome = true;
            block.group = j;
            group.push(block);
          }
        }

        if (bFoundHome == false) {
          block.group = groups.length;
          groups.push([block]);
        }
      }

    }

    // Now that all the blocks have assigned, run back over them
    // and assign the groupLength property to each
    for (i = 0; i < groups.length; i++) {
      group = groups[i];

      for (j = 0; j < group.length; j++) {

        block = group[j];

        if (block.isOverlap == true) {
          block.groupLength = groups.length;
        }
      }
    }

    // Primitives are passed by value; objects are passed by reference
    // Because the blocks are objects, the modifications in thie function
    // will persist, and we should now be able to return the blocks collection
    // itself.
    return blocks;
  };


	/**
	* Returns an Olson timezone string
	*
	* @method timeZone
	* @return {String | Null}
	*/
  self.timeZone = function () {
    var tz = qcal.timeZoneControl.selectedTZ();

    if (qcal) {

      if (tz) {
        return tz.olson[0];
      }
      else if (qcal.addAppointmentTicket.location() != null) {
        return qcal.addAppointmentTicket.location().timeZone;
      }
    }
    return null;
  };


	/**
	* Inspects the user selected timezone and updates appointments to account for any time shifts
	*
	* @method updateBlockTZs
	* @return none
	*/
  self.updateBlockTZs = function () {
    var tz = self.parent.timeZoneControl.selectedTZ();

    if (tz) {
      // self.blocks().forEach( function ( block ) {
      // 	block.updateTZ( tz.olson[0] );
      // });

      // self.blocks.valueHasMutated();
      var ww = new Worker('./res/js/app/ww/timeblockUpdaterWW.js');
      ww.postMessage({ tz: tz.olson[0], blocks: JSON.stringify(self.blocks()) });
      ww.onmessage = function (e) {
        // result.textContent = e.data;
        console.log(e);
        var b = JSON.parse(e.data.blocks);
        console.log(b)
      };
    }


  };

  // Return self ( PossibleTimeBlocksWS )
  return self;
};

PossibleTimeBlocksWS.prototype = AbstractWS.prototype;
PossibleTimeBlocksWS.prototype.constructor = PossibleTimeBlocksWS;
